import { Box, Paper, Typography, Alert, useTheme } from '@mui/material'
import { InfoOutlined, CheckCircleOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { alpha } from '@mui/material/styles'

const UserSpecificMessage = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, md: 5 },
          textAlign: 'center',
          maxWidth: 600,
          width: '100%',
          borderRadius: '12px',
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.palette.mode === 'dark' ? '0 10px 30px rgba(0,0,0,0.3)' : '0 10px 30px rgba(0,0,0,0.05)',
        }}
      >
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center', alignItems: 'center', width: 100, height: 100, borderRadius: '50%', backgroundColor: alpha(theme.palette.primary.main, 0.1), margin: '0 auto 24px' }}>
          <CheckCircleOutlined sx={{ fontSize: 50, color: theme.palette.primary.main }} />
        </Box>

        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, fontFamily: theme.typography.h1?.fontFamily, mb: 2, color: theme.palette.text.primary }}>
          {t('regular_user_message_title')}
        </Typography>

        <Typography variant="body1" paragraph sx={{ color: theme.palette.text.secondary, mb: 4, fontSize: '1.05rem', lineHeight: 1.6 }}>
          {t('regular_user_message_body')}
        </Typography>

        <Alert severity="info" icon={<InfoOutlined />} sx={{ mt: 2, mb: 2, borderRadius: '8px', '& .MuiAlert-message': { fontSize: '0.95rem' } }}>
          {t('contact_admin_message')}
        </Alert>
      </Paper>
    </Box>
  )
}

export default UserSpecificMessage
